<script>
  import Link from '../../utils/link.html';
  import Menu from '../../components/navigation/menu';
  import Archive from '../../components/buttons/trash';
  import Plus from '../../components/buttons/plus';
  import Loader from '../../components/ui/loader.html';
  import { onMount, afterUpdate, getContext } from "svelte";
  import { gql } from "apollo-boost";

  import {PROGRAM, UPDATE_PROGRAM} from '../../graphql/programs';

  import ProgramEvents from './components/sections/program.events';
  import ProgramPastEvents from './components/sections/program.past.events';
  import ProgramDetails from './components/sections/program.details';
  import ProgramCommunications from './components/sections/program.communications';

  import {addNotification, ICONS} from '../../utils/notifications.store';
  import {
    ADD_PROGRAM,
    programValueToInput
  } from '../../graphql/programs';



  const client = getContext('apollo');
  const history = getContext('history');

   const components = {
    'upcoming-events': ProgramEvents,
    'past-events': ProgramPastEvents,
    'details': ProgramDetails,
    'communications': ProgramCommunications
  }

  export let match = {};
  let loading = true;
  let _program;
  let error;
  $: current = components[match.params.section] || components['upcoming-events'];
  $: id = match.params.id;
  $: program = _program;

  

  $: menu = [
    {id:'upcoming-events', label: 'Upcoming Events', link:`/programs/view/${id}`},
    {id: 'past-events', label: 'Past Events', link:`/programs/view/${id}/past-events`},
    {id: 'details', label: 'Details', link:`/programs/view/${id}/details`},
    {id: 'communications', label: 'Communications', link:`/programs/view/${id}/communications`}
  ]

  async function getProgram() {
    console.log('get program', match.params.id);
    loading = true;
   
    try {
      const { data } = await client.query({
        query: PROGRAM,
        variables: { id: id}
      });

      // guards
      if(!data.program.category) {
        data.program.category = {};
      }

      if(!data.program.secondaryCategory) {
        data.program.secondaryCategory = {};
      }

      if(!data.program.coordinator) {
        data.program.coordinator = {};
      }

      _program = data.program;
      loading = false;
    } catch (e) {
      loading = false;
      error = e;
    }
  }

  function archiveProgram() {
    addNotification({
      message:`Are you sure you want to archive ${program.name}? It will no longer show up in the admin, but will remain assigned to existing events.`, 
      icon: ICONS.CONFIRM,
      confirm: commitArchiveProgram
    })
  }

  function duplicateProgram() {
    addNotification({
      message:`Are you sure you want to duplicate ${program.name}?`, 
      icon: ICONS.CONFIRM,
      confirm: commitDuplicateProgram
    })
  }

  async function commitDuplicateProgram() {
    const input = programValueToInput(program);

    input.name = `${input.name} - Duplicate`;

    try {
      addNotification({ icon: ICONS.LOADING, message: `Duplicating ${program.name}` });

      const response = await client.mutate({
        mutation: ADD_PROGRAM,
        variables: { input }
      });

      addNotification({
        time: 2000,
        message: `Successfully Duplicated ${program.name}`,
        icon: ICONS.SUCCESS
      });

     

      history.push(`/programs/view/${response.data.addProgram.id}`);
      match.params.id = response.data.addProgram.id;
      window.location.reload();
    } catch (e) {
      addNotification({
        message: `Error Duplicating ${value.name}`,
        icon: ICONS.ERROR,
        time: 2000
      });
    }

  }

  async function commitArchiveProgram() {
    try {
      addNotification({icon: ICONS.LOADING, message: `Archiving ${program.name}`});
      await client.mutate({mutation: UPDATE_PROGRAM, variables:{input: {id: program.id, archived: true}} });
      addNotification({icon: ICONS.SUCCESS, message: `Archived ${program.name}`, time: 2000});
      history.push('/programs');
    } catch (e) {
      console.log(e);
      addNotification({icon: ICONS.ERROR, message: `Something went wrong! Could not archive ${program.name}`, time: 2000})
    }
  }

  onMount(getProgram);

</script>

{#if loading}
  <Loader />
{/if}

{#if !loading}
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-4">
      <h1>{program.name}</h1>
    </div>
    <div class="cell small-12 medium-8 text-right">
      <Link href="{`/events/new/${id}`}"> 
        <Plus label="ADD PROGRAM EVENT" />
      </Link>
      <Archive on:click="{archiveProgram}" label={'ARCHIVE PROGRAM'} />
      <Plus on:click="{duplicateProgram}" label={'DUPLICATE PROGRAM'} />
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-12">
      <Menu active={match.params.section || 'upcoming-events'} items={menu} />
    </div>
  </div>

  <svelte:component this={current} bind:value={program} id={id} />
{/if}

